import { faClipboard } from '@fortawesome/pro-solid-svg-icons/faClipboard';
import { faSplit } from '@fortawesome/pro-solid-svg-icons/faSplit';
import { useReferralsSummary } from '@ukpostbox/client-data';
import {
	Button,
	ColourStateSolid,
	ContentBlock,
	ContentLoader,
	FlexGap,
	StackVertical,
	useNotifications,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React, { useEffect, useState } from 'react';
import { ReferralImage } from '../../Images/ReferralImage';
import ChangeSplitModal from '../../Components/Referrals/Modals/ChangeSplitModal';
import SendEmailModal from '../../Components/Referrals/Modals/SendEmailModal';
import { useSite } from '../../../_Global/Providers/SiteInterfaceProvider';

function ReferralsSummary() {
	const { t } = useTranslation();
	const { AddNotification } = useNotifications();
	const { currentLocale, updatePageMeta } = useSite();

	const { data, status, error } = useReferralsSummary();

	const [splitOpen, setSplitOpen] = useState<boolean>(false);
	const [inviteOpen, setInviteOpen] = useState<boolean>(false);

	const HandleCopy = async (value: string) => {
		AddNotification({
			title: t('results.copiedClipboard'),
			icon: faClipboard,
		});

		await navigator.clipboard.writeText(`${process.env.REACT_APP_CLIENT_HOST}/Signup?Referrer=${value}`);
	};

	useEffect(() => {
		updatePageMeta({
			title: t(`settings.sections.${'Referrals Summary'}`),
		});
	}, [currentLocale]);

	return status === 'pending' ? (
		<ContentLoader childCount={1} childWidth='100%' childHeight='100%' />
	) : status === 'error' ? (
		<ContentBlock error stacked title={error?.name} content={error?.message} extraClass='m-md' />
	) : (
		<>
			<div className='row'>
				<div className='col-center-lg-8'>
					<div className='text-center'>
						<ReferralImage />
						<h1>{t('settings.referralSummary.messages.commissionTitle')}</h1>
					</div>
				</div>
			</div>
			<div className='row mb-xxxl'>
				<div className='col-center-lg-6'>
					<p>{t('settings.referralSummary.messages.commissionDescription')}</p>

					<ul>
						<li>{t('settings.referralSummary.messages.commissionListItem')}</li>
						<li>{t('settings.referralSummary.messages.commissionListItem2')}</li>
					</ul>

					<p>{t('settings.referralSummary.messages.commissionDescription2')}</p>
					<p>{t('settings.referralSummary.messages.commissionDescription3')}</p>

					<StackVertical gap={FlexGap.ExtraSmall}>
						<Button
							fullWidth
							colour={ColourStateSolid.Primary}
							title={t('settings.referralSummary.actions.invite')}
							onClick={() => setInviteOpen(true)}
						/>
						<Button
							fullWidth
							colour={ColourStateSolid.Primary}
							title={t('settings.referralSummary.actions.copy')}
							onClick={() => HandleCopy(data.code)}
						/>
					</StackVertical>
				</div>
			</div>

			<div className='row'>
				<div className='col-center-lg-6'>
					<ContentBlock
						stacked
						iconContent={{ icon: faSplit }}
						title={`${t('settings.referralSummary.labels.currentSplit')} ${data?.split}%`}
						content={t('settings.referralSummary.messages.commissionSplitDescription')}
						addon={
							<Button
								fullWidth
								title={t('settings.referralSummary.actions.split')}
								onClick={() => setSplitOpen(true)}
							/>
						}
					/>
				</div>
			</div>

			<SendEmailModal isOpen={inviteOpen} closeCallback={() => setInviteOpen(false)} />

			<ChangeSplitModal
				currentSplit={data.split || 0}
				isOpen={splitOpen}
				closeCallback={() => setSplitOpen(false)}
			/>
		</>
	);
}

export { ReferralsSummary };
